import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

const get = (url) => () => api.get(url).then((r) => r.data);

export const useCatalog = () => useQuery({ queryKey: ["catalog"], queryFn: get("/catalog"), staleTime: Infinity });
export const usePatients = () => useQuery({ queryKey: ["patients"], queryFn: get("/patients"), staleTime: 0 });
export const usePatient = (pid) => useQuery({ queryKey: ["patient", pid], queryFn: get(`/patients/${pid}`), enabled: !!pid, staleTime: 0 });
export const useProgress = (pid) => useQuery({ queryKey: ["progress", pid], queryFn: get(`/patients/${pid}/progress`), enabled: !!pid, staleTime: 0 });
export const useSessions = (pid) =>
  useQuery({ queryKey: ["sessions", pid || "all"], queryFn: get(`/sessions${pid ? `?patient_id=${pid}` : ""}`), staleTime: 0 });

export const missionName = (catalog, key) => catalog?.missions.find((m) => m.key === key)?.name_fr || key;
